import React from "react";
import SbEditable from "storyblok-react";
import Heading from '../Heading';
import Slider from "react-slick";

/* TBB */

const LogoCarousel = ({ blok }) => {

    const NextArrow = ({ onClick }) => {
        return (
            <div
                onClick={onClick}
                onKeyDown={onClick}
                role="button"
                tabIndex="0"
                className={`w-9 h-9 rounded-full flex justify-center items-center absolute xl:-right-20 -right-9 top-[calc(50%-36px)] xl:bottom-0 bottom-0`}
            >
                <i className="fal fa-long-arrow-right cursor-pointer transition duration-300 text-lg"></i>
            </div>
        );
    };

    const PrevArrow = ({ onClick }) => {
        return (
            <div
                onClick={onClick}
                onKeyDown={onClick}
                role="button"
                tabIndex="0"
                className={`w-9 h-9 rounded-full flex justify-center items-center absolute xl:-left-20 -left-9 top-[calc(50%-36px)] xl:bottom-0 bottom-0`}
            >
                <i className="fal fa-long-arrow-left cursor-pointer transition duration-300 text-lg"></i>
            </div>
        );
    };

    return (
        <SbEditable content={blok} key={blok._uid}>
            <div className="bg-white">
                <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:py-16 lg:px-8">
                    <h2 className="font-body font-semibold text-base leading-6 text-pink mb-4 text-center">{blok.title}</h2>
                    <Heading className={"text-center text-darkblue"}>
                        {blok.subtitle}
                    </Heading>
                    <div className="mt-6">
                        <Slider
                            className="pb-8 mx-9"
                            dots={true}
                            infinite={true}
                            slidesToShow={6}
                            slidesToScroll={1}
                            autoplay={true}
                            autoplaySpeed={3000}
                            speed={600}
                            cssEase="ease"
                            arrows={true}
                            nextArrow={<NextArrow />}
                            prevArrow={<PrevArrow />}
                            pauseOnHover={true}
                            pauseOnFocus={false}
                            swipe={false}
                            responsive={[
                                {
                                    breakpoint: 768,
                                    settings: {
                                        slidesToShow: 2,
                                        slidesToScroll: 1,
                                    },
                                }
                            ]}
                        >
                            {blok.items.map((logo, index) => (
                                <div className="p-1 w-full h-32 focus:outline-none outline-none" key={index}>
                                    <div className="h-full w-full flex justify-center items-center">
                                        <img className="h-12" src={logo.filename} alt={logo.alt || "Logo"} />
                                    </div>
                                </div>
                            ))}
                        </Slider>
                    </div>
                </div>
            </div>
        </SbEditable >
    );
};

export default LogoCarousel;
